import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/ericmalek/Desktop/Portfolio/ej-claude/ejclaude/node_modules/next/dist/client/app-dir/link.js");
